"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _loglevel = _interopRequireDefault(require("loglevel"));
var _RPC_ERRORS;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * JSON-RPC error object
 *
 * @typedef {Object} RpcError
 * @property {number} code - Indicates the error type that occurred
 * @property {Object} [data] - Contains additional information about the error
 * @property {string} [message] - Short description of the error
 */

/**
 * Middleware configuration object
 *
 * @typedef {Object} MiddlewareConfig
 * @property {boolean} [override] - Use RPC_ERRORS message in place of provider message
 */

/**
 * Map of standard and non-standard RPC error codes to messages
 */
var RPC_ERRORS = (_RPC_ERRORS = {
  1: 'An unauthorized action was attempted.',
  2: 'A disallowed action was attempted.',
  3: 'An execution error occurred.'
}, _defineProperty(_RPC_ERRORS, -32600, 'The JSON sent is not a valid Request object.'), _defineProperty(_RPC_ERRORS, -32601, 'The method does not exist / is not available.'), _defineProperty(_RPC_ERRORS, -32602, 'Invalid method parameter(s).'), _defineProperty(_RPC_ERRORS, -32603, 'Internal JSON-RPC error.'), _defineProperty(_RPC_ERRORS, -32700, 'Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text.'), _defineProperty(_RPC_ERRORS, "internal", 'Internal server error.'), _defineProperty(_RPC_ERRORS, "unknown", 'Unknown JSON-RPC error.'), _RPC_ERRORS);
/**
 * Modifies a JSON-RPC error object in-place to add a human-readable message,
 * optionally overriding any provider-supplied message
 *
 * @param {RpcError} error - JSON-RPC error object
 * @param {boolean} override - Use RPC_ERRORS message in place of provider message
 */

function sanitizeRPCError(error, override) {
  if (error.message && !override) {
    return error;
  }
  var message = error.code > -31099 && error.code < -32100 ? RPC_ERRORS.internal : RPC_ERRORS[error.code];
  error.message = message || RPC_ERRORS.unknown;
}
/**
 * json-rpc-engine middleware that both logs standard and non-standard error
 * messages and ends middleware stack traversal if an error is encountered
 *
 * @param {MiddlewareConfig} [config={override:true}] - Middleware configuration
 * @returns {Function} json-rpc-engine middleware function
 */

function createErrorMiddleware() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$override = _ref.override,
    override = _ref$override === void 0 ? true : _ref$override;
  return function (req, res, next) {
    next(function (done) {
      var error = res.error;
      if (!error) {
        return done();
      }
      sanitizeRPCError(error);
      _loglevel.default.error("Torus - RPC Error: ".concat(error.message), error);
      done();
    });
  };
}
var _default = createErrorMiddleware;
exports.default = _default;